import { render, staticRenderFns } from "./purchaseItems.vue?vue&type=template&id=e1a04846&scoped=true&"
import script from "./purchaseItems.vue?vue&type=script&lang=js&"
export * from "./purchaseItems.vue?vue&type=script&lang=js&"
import style0 from "./purchaseItems.vue?vue&type=style&index=0&id=e1a04846&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a04846",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VBtnToggle,VCol,VDataTable,VIcon,VRow})
